import { CONTENT_GROUP_ACTION, userConstants } from '../constants';
import { sortByField } from '../utils/sortByField';

const initialState = { 
  loading: false, 
  error: '', 
  attachment_downloading: false,
  content_loading: false, 
};

const initialAuthorization = {
    can_add: null,
    currentContentGroupWorkspaceForChat: null,
    assigned_users: null,
    can_assign_user: null,
    can_access_submit_approval: null,
    can_access_accept_revision: null,
    can_access_reject_revision: null,
    can_access_add_change_date: null,
    can_access_accept_request_revision: null,
    can_access_content_update: null,
    can_access_content_create: null,
    can_access_team_comment: null,
    can_access_show_team_comment: null,
    can_access_content_versions: null,
    can_access_content_hide: null,
    can_access_content_destroy: null,
    can_access_content_comment: null,
    can_access_content_download: null,
    can_access_content_group_archive: null,
    can_access_assigned_user: null,
    can_access_move_content_board: null,
    can_access_show_content_details: null,
    can_access_clone_content_group: null,
    can_access_edit_label: null,
    can_sort_attachments: null,
}

export function content(state = initialState, action) {
  switch (action.type) {
    case userConstants.PAGE_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case userConstants.REMOVE_CONTENT_GROUP: {
      return {
        ...state,
        loading: false,
        currentContentGroup: null,
        contents: [],
        currentWorkSpace: null,
        currentContent: null,
        ...initialAuthorization
      };
    }

    case userConstants.CONTENT_LOADING: {
      return {
        ...state,
        content_loading: true
      };
    }

    case userConstants.CONTENT_LOADING_STOP: {
      return {
        ...state,
        content_loading: false
      };
    }

    case userConstants.CONTENT_FAILURE: {
      return {
        ...state,
        loading: false,
        content_loading: false,
        error:action.payload
      };
    }

    case CONTENT_GROUP_ACTION.READ_GUEST_COMMENTS: {
      const currentContentGroup = state.currentContentGroup || {};
      const { unread_comments } = currentContentGroup;

      return {
        ...state,
        currentContentGroup: {
          ...currentContentGroup,
          unread_comments: {
            ...unread_comments,
            guest: false
          }
        }
      }
    }

    case CONTENT_GROUP_ACTION.READ_TEAM_COMMENTS: {
      const currentContentGroup = state.currentContentGroup || {};
      const { unread_comments } = currentContentGroup;

      return {
        ...state,
        currentContentGroup: {
          ...currentContentGroup,
          unread_comments: {
            ...unread_comments,
            team: false
          }
        }
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_UNREAD_COMMENTS: {
      const { unread_comments } = action.payload;
      return {
        ...state,
        currentContentGroup: {
          ...state.currentContentGroup,
          unread_comments: unread_comments
        }
      }
    }

    case userConstants.NEW_CONTENT: {
      return {
        ...state,
        currentWorkSpace: action.payload.data.workspace,
        currentContentGroup: action.payload.data.content_group,
        contents: action.payload.data.contents,
        loading: false
      }
    }

    case userConstants.CONTENT_SHOW: {
      return {
        ...state,
        currentContent: action.payload.data.first_record,
        currentContentGroup: action.payload.data.content_group,
        currentWorkSpace: action.payload.data.workspace,
        //loading: false,
        //content_loading: false
      };
    }

    case userConstants.CONTENT_VERSION: {
      return {
        ...state,
        currentContent: action.payload.data.content,
        currentContentGroup: action.payload.data.content_group,
        currentWorkSpace: action.payload.data.workspace,
        versions: action.payload.data.versions,
        loading: false
      };
    }

    case userConstants.CONTENT_VERSION_SHOW: {
      return {
        ...state,
        currentContent: action.payload.data.content,
        currentContentGroup: action.payload.data.content_group,
        currentWorkSpace: action.payload.data.workspace,
        currentVersion: action.payload.data.version,
        loading: false
      };
    }


    case userConstants.CONTENT_REQUEST: {
      return {
        ...state,
        editContent: null,
        loading: false
      };
    }

    case userConstants.GET_CONTENT:{
      return{
        ...state,
        contents: action.payload.data.data,
        can_add: action.payload.data.can_add,
        currentContentGroupWorkspaceForChat: action.payload.data.content_group_workspace_for_chat,
        currentContentGroup: action.payload.data.content_group,
        assigned_users: action.payload.data.assigned_users,
        can_assign_user: action.payload.data.can_assign_user,
        can_access_submit_approval: action.payload.data.can_access_submit_approval,
        can_access_accept_revision: action.payload.data.can_access_accept_revision,
        can_access_reject_revision: action.payload.data.can_access_reject_revision,
        can_access_add_change_date: action.payload.data.can_access_add_change_date,
        can_access_accept_request_revision: action.payload.data.can_access_accept_request_revision,
        can_access_content_update: action.payload.data.can_access_content_update,
        can_access_content_create: action.payload.data.can_access_content_create,
        can_access_team_comment: action.payload.data.can_access_team_comment,
        can_access_show_team_comment: action.payload.data.can_access_show_team_comment,
        can_access_content_versions: action.payload.data.can_access_content_versions,
        can_access_content_hide: action.payload.data.can_access_content_hide,
        can_access_content_destroy: action.payload.data.can_access_content_destroy,
        can_access_content_comment: action.payload.data.can_access_content_comment,
        can_access_content_download: action.payload.data.can_access_content_download,
        can_access_content_group_archive: action.payload.data.can_access_content_group_archive,
        can_access_assigned_user: action.payload.data.can_access_assigned_user,
        can_access_move_content_board: action.payload.data.can_access_move_content_board,
        can_access_show_content_details: action.payload.data.can_access_show_content_details,
        can_access_edit_label: action.payload.data.can_access_edit_label,
        can_sort_attachments: action.payload.data.can_sort_attachments,
        can_access_clone_content_group: action.payload.data.can_access_clone_content_group,

        loading: false,
        content_loading: false
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CONTENT_GROUP_ASSIGNED_USERS: {
      const { assigned_users, card } = action.payload;

      if (card.id === state?.currentContentGroup?.id) {
        return {
          ...state,
          currentContentGroup: {
            ...state.currentContentGroup,
            assigned_users: assigned_users
          }
        }
      } else {
        return state;
      }
    }

    case CONTENT_GROUP_ACTION.ADD_LABEL_TO_CARD: {
      const { label, card } = action.payload;
      
      // Only update if this card is currently selected
      if (card.id === state?.currentContentGroup?.id) {
        // Get current labels, remove any existing version of this label, add new label
        const updatedLabels = [
          ...state.currentContentGroup.labels.filter(l => l.id !== label.id),
          label
        ];

        // Get current label IDs and add new label ID
        const updatedLabelIds = [
          ...state.currentContentGroup.label_ids.filter(l => l !== label.id),
          label.id
        ];

        return {
          ...state,
          currentContentGroup: {
          ...state.currentContentGroup,
          labels: [...new Set(updatedLabels)], // Remove duplicates
          label_ids: [...new Set(updatedLabelIds)] // Remove duplicates
          }
        }
      }
      
      return state;
    }


    case CONTENT_GROUP_ACTION.REMOVE_LABEL_FROM_CARD: {
      const { label, card } = action.payload;
      
      // Only update if this card is currently selected
      if (card.id === state?.currentContentGroup?.id) {
        // Get current labels, remove any existing version of this label, add new label
        const updatedLabels = [
          ...state.currentContentGroup.labels.filter(l => l.id !== label.id)
        ];

        // Get current label IDs and add new label ID
        const updatedLabelIds = [
          ...state.currentContentGroup.label_ids.filter(l => l !== label.id)
        ];

        return {
          ...state,
          currentContentGroup: {
            ...state.currentContentGroup,
            labels: [...new Set(updatedLabels)], // Remove duplicates
            label_ids: [...new Set(updatedLabelIds)] // Remove duplicates
          }
        }
      }
      
      return state;
    }

    case CONTENT_GROUP_ACTION.ADD_ATTACHMENTS_TO_CARD: {
      const { attachments, card } = action.payload;

      if (card.id === state?.currentContentGroup?.id) {
        const updatedAttachments = [
          ...state.contents,
          ...attachments
        ];

        return {
          ...state,
          contents: sortByField(updatedAttachments, 'position', 'asc')
        }
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_ATTACHMENTS_IN_CARD: {
      const { attachments, card } = action.payload;

      if (card.id === state?.currentContentGroup?.id) {
        const updatedContents = state.contents.map(content => {
          const updatedAttachment = attachments.find(att => att.id === content.id);
          return updatedAttachment ? updatedAttachment : content;
        });

        return {
          ...state,
          contents: updatedContents
        }
      } else {
        return state;
      }
    }

    case CONTENT_GROUP_ACTION.REMOVE_ATTACHMENTS_FROM_CARD: {
      const { destroyed_attachment_ids, card } = action.payload;

      if (card.id === state?.currentContentGroup?.id) {
        const updatedContents = state.contents.filter(({ id }) => !destroyed_attachment_ids.includes(id));

        return {
          ...state,
          contents: updatedContents
        }
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CONTENT_GROUP_ASSIGNED_USERS: {
      const { assigned_users, card } = action.payload;

      if (card.id === state?.currentContentGroup?.id) {
      return {
        ...state,
        currentContentGroup: {
        ...state.currentContentGroup,
        assigned_users: assigned_users
        }
        }
      } else {
        return state;
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CONTENT_GROUP_POPUP: {
      const content_group_popup = action.payload;

      if (state?.currentContentGroup === null) {
        return state;
      }

      if (state?.currentContentGroup?.id === content_group_popup?.id) {
        return {
          ...state,
          currentContentGroup: {
            ...state.currentContentGroup,
            ...content_group_popup
          }
        }
      }

      return {
        ...state
      }
    }

    case CONTENT_GROUP_ACTION.SET_AUTHORIZATIONS: {
      const { authorizations } = action.payload.data;
      return {
        ...state,
        ...authorizations, // See initialAuthorization for structure
      };
    }

    case CONTENT_GROUP_ACTION.SET_ASSIGNED_USERS: {
      const { assigned_users } = action.payload.data;
      return {
        ...state,
        assigned_users: assigned_users,
      };
    }

    case userConstants.GET_AUTHORIZED_USERS:{
      return{
        ...state,
        authorized_users: action.payload.data.authorized_users,
        loading: false
      }
    }

    case userConstants.EDIT_CONTENT:{
      return {
        ...state,
        editContent: action.payload.data.first_record,
        currentWorkSpace: action.payload.data.workspace,
        currentContentGroup: action.payload.data.content_group,
        contents: action.payload.data.contents,
        loading: false,
        content_loading: false
      }
    }

    case userConstants.DELETE_CONTENT:{
      let id = action.payload.data.data.id
      return {
        ...state,
        contents: state.contents.filter(item => item.id !== id),
        loading: false
      }
    }

    case userConstants.DELETE_CONTENTS:{
      return {
        ...state,
        contents: state.contents.filter(({ id }) => !action.payload.includes(id)),
        loading: false
      }
    }

    case userConstants.SUBMIT_CONTENTGROUP:{
      return {
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.VOID_SUBMIT_CONTENTGROUP:{
      return {
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.APPROVE_CONTENTGROUP:{
      return {
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.REJECT_CONTENTGROUP:{
      return {
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.REJECT_REQUEST_CONTENTGROUP:{
      return{
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.ACCEPT_REQUEST_CONTENTGROUP:{
      return{
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data
      }
    }

    case userConstants.UPDATE_CONTENT:{
      return {
        ...state,
        loading: false,
        content_loading: false
      }
    }

    case userConstants.CONTENT_INLINE_UPDATE:{
      return {
        ...state,
        loading: false,
        currentContentGroup: action.payload.data.data,
        currentContent: action.payload.data.contents[0],
        contents: action.payload.data.contents,
        content_loading: false
      }
    }

    case userConstants.CONTENT_INLINE_EDIT: {
      let contentGroupDetail = action.payload.data
      let resultUpdateInlineEdit = ""
      if(state.currentContentGroup && state.currentContentGroup) {
        resultUpdateInlineEdit = {
          ...state.currentContentGroup,
          start_date: contentGroupDetail.start_date,
          due_date: contentGroupDetail.due_date
        }
      }
      return {
        ...state,
        loading: false,
        currentContentGroup: contentGroupDetail,
        content_loading: false
      }
    }

    case CONTENT_GROUP_ACTION.DOWNLOADING_ATTACHMENT: {
      return {
        ...state,
        attachment_downloading: true
      };
    }

    case CONTENT_GROUP_ACTION.DOWNLOADED_ATTACHMENT: {
      return {
        ...state,
        attachment_downloading: false
      };
    }

    case userConstants.ASSIGN_LABEL_IN_CONTENT: {
      let currentLabel = action.payload
      let resultLabelUpdate = ""
      if(state.currentContentGroup && state.currentContentGroup) {
        let contentGroup = [state.currentContentGroup]
        resultLabelUpdate = contentGroup && contentGroup.map((el, index) => {
          return { ...el, labels: currentLabel.data.content_labels };
        })
      }
      return {
        ...state,
        loading: false,
        currentContentGroup: resultLabelUpdate && resultLabelUpdate.reduce((a, b) => Object.assign(a, b), {}),
        content_loading: false
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_STAGE_INFO: {
      const card = action.payload;
      if (card.id === state?.currentContentGroup?.id) {
        return {
          ...state,
          currentContentGroup: {
            ...state.currentContentGroup,
            stage: card.stage,
            submitted: card.submitted,
            approved: card.approved
          }
        }
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_UNREAD_COMMENTS: {
      const card = action.payload;
      
      if (card.id === state?.currentContentGroup?.id) {
        return {
          ...state,
          currentContentGroup: {
            ...state.currentContentGroup,
            unread_comments: card.unread_comments
          }
        }
      } else {
        return state;
      }
    }

  default:
    return state
  }
}
